export function productDpdFilter(prefixes: string) {
  const arr = prefixes
    .split(",")
    .map(v => v.trim())
    .filter(Boolean)
  return {
    and: arr.map(prefix => ({ not: { matches: { body: { like: prefix } } } })),
  }
}
